export enum Role {
    Admin = "Admin",
    Worker = "Worker",
    Foreman = "Foreman",
    Analytics = "Analytics",
    AllRegs = "AllRegs",
}


export type  CurrentUserInfo = {
    id: string
    fullName: string
    avatarUrl: string
    email: string
    defaultWorkerID:number|null,
    worker: {
        id: number,
        firstName: string,
        lastName: string,
        code: string,
        partnerCode: string,
    }
    userRoles: {roles:  Array<Role>}
}



export type  SessionState = {
    user: CurrentUserInfo | null
    initialized: Boolean
    message: string
    locale: string,
    themeMode: "dark" | "light",
}
